import { getAppState } from "../../state";
import { getRouteByPath, routes, sections } from "../../routes";
import { config } from "../../config/config";
import { isAccessLimitedByParentalLevel } from "../../services/parentalControlService";
import { trackEvent } from "../../services/analyticsService";

export default function() {
  const userLogged = getAppState().userLogged;
  const isKids = isAccessLimitedByParentalLevel();

  /**
   * The list of items to display in the main menu of the application.
   * @type {Object[]} An array of objects that can contain a set of properties.
   * - path: A path to which the application will have to go if this item is selected.
   * - name: (optional) The title to be displayed on the item (mandatory if icon not provided).
   * - icon: (optional) An icon to be displayed on the item, instead of a text (mandatory if name not provided).
   * - show: (optional) A boolean value that specifies if the item should be visible or not. Default is true.
   * - sticky: (optional) A boolean value that specifies if the app should keep the item selected when coming back from
   *   the section it sends the app to when selected.
   */
  const menuItems = [
    {
      path: routes.pin,
      name: "login",
      icon: "user",
      show: !userLogged
    },
    {
      path: routes.kids,
      name: sections.KIDS,
      icon: "kids",
      background: `${config.get().ui.urlCdn}/MainMenu/kids.jpg`
    },
    {
      path: routes.search,
      name: sections.SEARCH,
      icon: "search",
      iconDescription: "Search icon",
      sticky: true,
      callback: function() {
        trackEvent("search|new", "open", this.props.history.location.pathname);
      }
    },
    {
      path: routes.home,
      name: sections.HOME,
      icon: "home",
      background: `${config.get().ui.urlCdn}/MainMenu/home.jpg`,
      show: !isKids
    },
    {
      path: routes.sports,
      name: sections.SPORTS,
      icon: "sports",
      background: `${config.get().ui.urlCdn}/MainMenu/sports.jpg`,
      show: !isKids
    },
    {
      path: routes.series,
      name: sections.SERIES,
      icon: "tvshows",
      background: `${config.get().ui.urlCdn}/MainMenu/series.jpg`,
      show: !isKids
    },
    {
      path: routes.movies,
      name: sections.MOVIES,
      icon: "movies",
      background: `${config.get().ui.urlCdn}/MainMenu/movies.jpg`,
      show: !isKids
    },
    {
      path: routes.arabic,
      name: sections.ARABIC,
      icon: "arabic",
      background: `${config.get().ui.urlCdn}/MainMenu/arabic.jpg`,
      show: !isKids
    },

    // ...channelMenuList(isKids),
    {
      path: routes.brands,
      icon: "subscription",
      name: sections.BRANDS,
      lockIconShouldAppear: true,
      background: `${config.get().ui.urlCdn}/MainMenu/channels.jpg`,
      show: !isKids
    },
    {
      path: routes.live,
      icon: "liveIcon",
      name: sections.LIVE,
      lockIconShouldAppear: true,
      background: `${config.get().ui.urlCdn}/MainMenu/live.jpg`,
      show: !isKids
    },
    {
      path: routes.mylibrary,
      icon: "myList",
      name: sections.MYLIBARAY,
      lockIconShouldAppear: true,
      iconDescription: "My library icon",
      show: userLogged,
      sticky: true
    },
    {
      path: routes.store,
      name: sections.STORE,
      icon: "store",
      background: `${config.get().ui.urlCdn}/MainMenu/home.jpg`,
      show: !isKids
    },
    {
      path: routes.settings,
      name: "settings",
      icon: "settings",
      iconDescription: "Settings icon",
      sticky: true
    }
  ];
  return menuItems
    .filter(item => (item.show !== undefined ? item.show : true))
    .map(filtered => ({
      ...filtered,
      isRoot: getRouteByPath(filtered.path).isRoot
    }));
}

export const customSettings = {
  discovery: {
    iconWidth: "5vw",
    iconHeight: "4vw"
  },
  ufc: {
    iconWidth: "5vw",
    iconHeight: "5vw"
  },
  blutv: {
    iconWidth: "5vw",
    iconHeight: "5vw"
  },
  fifa: {
    iconWidth: "5vw",
    iconHeight: "5vw"
  },
  premiersports: {
    iconWidth: "5vw",
    iconHeight: "5vw"
  },
  adsports: {
    iconWidth: "7vw",
    iconHeight: "7vw"
  },
  criclife: {
    iconWidth: "7vw",
    iconHeight: "4vw"
  },
  majidtv: {
    iconWidth: "5vw",
    iconHeight: "4vw"
  },
  golftv: {
    iconWidth: "7vw",
    iconHeight: "7vw"
  }
};
